import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const WindowStateActions = createActionGroup({
  source: 'WindowState',
  events: {
    'Request To Minimize Window': emptyProps(),
    'Close Window': emptyProps(),
    'Request To Open Window': props<{ context?: string }>(),
    'Open Window': emptyProps(),
    'End Session To Start New': props<{ pendingAction: PendingAction }>(),
  },
});
